import React, { useId } from "react";


export function PageHeader({
  eyebrow,
  title,
  description,
  action,
  onAction
}) {
  return (
    <div className="page-header">

      <div>

        <div className="eyebrow">
          {eyebrow}
        </div>

        <h1>
          {title}
        </h1>

        <p>
          {description}
        </p>

      </div>


      {action && (

        <button
          className="btn btn-dark rounded-3 px-3"
          onClick={onAction}
        >

          <i className="bi bi-plus-lg me-2"></i>

          {action}

        </button>

      )}

    </div>
  );
}


export function Toggle({
  checked,
  onChange,
  label = "Toggle",
  disabled = false
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      className={`switch ${
        checked ? "on" : ""
      }`}
      onClick={() =>
        onChange?.(!checked)
      }
    >

      <span />

    </button>
  );
}


export function SearchBar({
  value,
  onChange,
  placeholder = "Search..."
}) {
  return (
    <div className="search-box">

      <i className="bi bi-search"></i>

      <input
        value={value}
        onChange={(e) =>
          onChange(e.target.value)
        }
        placeholder={placeholder}
      />

    </div>
  );
}


export function FormField({
  label,
  children,
  help,
  error
}) {
  const generated = useId();
  const kids = React.Children.toArray(children);
  const at = kids.findIndex((k) => React.isValidElement(k) && ["input", "select", "textarea"].includes(k.type));
  const fieldId = at >= 0 ? (kids[at].props.id || `ff-${generated.replace(/:/g, "")}`) : undefined;
  return (
    <div className="mb-3">

      <label className="form-label" htmlFor={fieldId}>
        {label}
      </label>

      {at >= 0 ? kids.map((k, i) => (i === at ? React.cloneElement(k, { id: fieldId, "aria-invalid": error ? true : undefined }) : k)) : children}

      {error && (
        <div className="text-danger small mt-1" role="alert">
          {error}
        </div>
      )}

      {!error && help && (
        <div className="form-help">
          {help}
        </div>
      )}

    </div>
  );
}


export function Drawer({
  title,
  subtitle,
  onClose,
  children,
  footer
}) {
  return (
    <div
      className="drawer-backdrop"
      onMouseDown={onClose}
    >

      <div
        className="drawer"
        onMouseDown={(e) =>
          e.stopPropagation()
        }
      >

        <div className="drawer-header">

          <div>

            <h3>
              {title}
            </h3>

            {subtitle && (
              <p>
                {subtitle}
              </p>
            )}

          </div>

          <button
            className="icon-btn"
            onClick={onClose}
          >

            <i className="bi bi-x-lg"></i>

          </button>

        </div>


        <div className="drawer-body">

          {children}

        </div>


        <div className="drawer-footer">

          {footer}

        </div>

      </div>

    </div>
  );
}


export function Select({
  children,
  ...props
}) {
  return (
    <select
      className="form-select"
      {...props}
    >
      {children}
    </select>
  );
}